import { useMutation } from '@tanstack/react-query';
import { usePermissionsRepository } from '@Hooks/useRepository';
import { ClientRepository } from '@Repositories/Permissions';

interface AcceptClientLegalDocuments {
    clientId: string;
    dataProcessingAgreementVersion: number;
    termsOfServiceVersion: number;
}

export const useAcceptClientLegalDocuments = () => {
    const clients = usePermissionsRepository(ClientRepository);

    return useMutation({
        mutationFn: (config: AcceptClientLegalDocuments) =>
            clients.acceptClientLegalDocuments(config.clientId, {
                data_processing_agreement_version: config.dataProcessingAgreementVersion,
                terms_of_service_version: config.termsOfServiceVersion,
            }),
    });
};
